import { mediaQuery } from '../enums/mediaQuery';
import useMediaQuery from './useMediaQuery';

export const useTablet = () => {
  return useMediaQuery(mediaQuery.TABLET);
};
